import React, { useEffect, useState } from 'react';
import { Link as Anchor } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../../Components/Admin/Auth/Auth.css';
import '../../Components/Admin/Login/Login.css';
import defaultLogo from '../../images/logo.png';
import baseURL from '../../Components/url';
import { guardarSiteConfig, obtenerLogoGuardado } from '../../Components/siteConfig';

export default function RecuperarContrasena() {
    const [email, setEmail] = useState('');
    const [cargando, setCargando] = useState(false);
    const [appLogo, setAppLogo] = useState(() => obtenerLogoGuardado() || defaultLogo);

    useEffect(() => {
        const cargarLogo = async () => {
            try {
                const response = await fetch(`${baseURL}/configGet.php`);
                const data = await response.json();

                if (data.config) {
                    guardarSiteConfig(data.config);
                }

                if (data.config?.logo) {
                    setAppLogo(data.config.logo);
                }
            } catch (error) {
                console.error('Error al cargar el logo de recuperacion:', error);
            }
        };

        cargarLogo();
    }, []);

    const solicitarRecuperacion = async (event) => {
        event.preventDefault();
        setCargando(true);

        try {
            const formData = new FormData();
            formData.append('email', email);

            const response = await fetch(`${baseURL}/adminPasswordResetRequest.php`, {
                method: 'POST',
                body: formData
            });

            const data = await response.json();

            if (data.mensaje) {
                toast.success(data.mensaje);
                setEmail('');
            } else if (data.error) {
                toast.error(data.error);
            }
        } catch (error) {
            console.error('Error al solicitar recuperacion:', error);
            toast.error('No se pudo enviar la solicitud de recuperacion.');
        } finally {
            setCargando(false);
        }
    };

    return (
        <div className='AuthContainer'>
            <Anchor to={`/dashboard`} >
                <img src={appLogo} alt="Logo de la tienda" className='logoAtuh' />
            </Anchor>

            <div className='formContain'>
                <h2>Recuperar clave</h2>
                <p className='helperAuth'>Este acceso esta disponible solo para cuentas administradoras.</p>

                <form onSubmit={solicitarRecuperacion} className='formAuth'>
                    <div className='inputsAuth'>
                        <label htmlFor="email">Email:</label>
                        <input
                            type="email"
                            id="email"
                            name="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            placeholder="Correo del administrador"
                        />
                    </div>

                    {cargando ? (
                        <button type="button" className='btn' disabled>
                            Enviando...
                        </button>
                    ) : (
                        <button type="submit" className='btn'>
                            Enviar enlace
                        </button>
                    )}
                </form>

                <Anchor to={`/dashboard`} className='linkAuth'>
                    Volver al acceso administrador
                </Anchor>
            </div>
        </div>
    );
}
